import * as Html from "../util/Html.ts";
export {initDom}
Html.registerWidget('widget/list-sharing',{initDom:initDom})

function initDom(div: HTMLElement){
   var
    controller = div.getAttribute("data-controller-name") || "controller",
    main = div.querySelector<HTMLInputElement>('input[name="'+controller+'"]'),
    textSharedOn = div.querySelector('.fw-shared-text-on') as HTMLElement,
    textSharedOff = div.querySelector('.fw-shared-text-off') as HTMLElement,
    memberPicker = div.querySelector('.fw-member-picker') as HTMLElement,
    toAllcontroller = div.querySelector<HTMLInputElement>('input[name="sharedToAll"]'),
    others = div.querySelectorAll<HTMLInputElement>('input[name="sharedMemberIds"]');

  // Créer et ajouter l'input hidden
  const emptyInput = document.createElement('input');
  emptyInput.type = 'hidden';
  emptyInput.name = 'sharedMemberIds';
  emptyInput.value = '$empty';
  div.appendChild(emptyInput);

  function setEmpty(){
    const checkedCount = Array.from(others).filter(input => input.checked).length;
    emptyInput.disabled = checkedCount !== 0;
  }

  function init(){
    var open = (main.value === 'true');
    textSharedOn.style.display = open ? '' : 'none';
    textSharedOff.style.display = !open ? '' : 'none';
    memberPicker.style.display = open ? '' : 'none';
    setEmpty();
    return open;
  }
  init();

  main.addEventListener('change', function(){
    var open = init();
    if(open){
      toAllcontroller.value = 'true';
      toAllcontroller.dispatchEvent(new Event('ui-change'));
      others.forEach(input => {
        input.checked = true;
        input.dispatchEvent(new Event('ui-change'));
      });
    }else{
      toAllcontroller.value = 'false';
      toAllcontroller.dispatchEvent(new Event('ui-change'));
      others.forEach(input => {
        input.checked = false;
        input.dispatchEvent(new Event('ui-change'));
      });
    }
    setEmpty();
  });

  toAllcontroller.addEventListener('change', function(){
    var toAllChecked = toAllcontroller.value === 'true';
    others.forEach(input => {
      input.checked = toAllChecked;
      input.dispatchEvent(new Event('ui-change'));
    });
    setEmpty();
  });

  others.forEach(input => {
    input.addEventListener('change', function(){
      var checked = input.checked;
      if(!checked){
        toAllcontroller.value = 'false';
        toAllcontroller.dispatchEvent(new Event('ui-change'));
      }
      setEmpty();
    });
  });
}